import { map } from 'lodash';
import moment from 'moment';
import { RecurringMeetingModel } from './recurring-meeting-model';
import { formatStartToAPI } from '../../administration/constants/scheduler';
import { DashboardPMResponse } from '../interfaces/pm-dashboard.response';

export class ScheduleEventSaveModel {
  formJSON: string;
  meetingType: number;
  providerMeetingSk: string;
  personSk: string;
  location: string;
  offerDate: string;
  currScheduleDt: string;
  currScheduleEndDt: string;
  rescheduleReason: string;
  dateRescheduled: string;
  lastModUser: string;
  lastModTs: string;
  meetingName: string;
  subMeetingType: number;
  recurringMeetingInfo: RecurringMeetingModel;
  isRecurring: boolean;
  assignments: Assignments[];
  sessionType: number;
  status: number;
  studentSk: string;
  providerSk: string;
  locationType: number;
  locationKey: string;
  students: DashboardPMResponse[];
  constructor(data: any) {
    const combinedCurrScheduleEndDt = moment(data?.startDate)
      .set({
        hour: moment(data?.endTime).hours(),
        minute: moment(data?.endTime).minutes(),
      });
    const combinedCurrScheduleDt = moment(data?.startDate)
      .set({
        hour: moment(data?.startTime).hours(),
        minute: moment(data?.startTime).minutes(),
      });
    const currScheduleDtStr =
      combinedCurrScheduleDt.local().format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    const currScheduleEndDtStr =
      combinedCurrScheduleEndDt.local().format('YYYY-MM-DDTHH:mm:ss') + 'Z';

    // replace startTime/endTime in the payload with the computed schedule datetimes
    data.startTime = currScheduleDtStr;
    data.endTime = currScheduleEndDtStr;
    const formData = {
      ...data,
      startDate: formatStartToAPI(data.startDate)
    };
    this.formJSON = JSON.stringify(formData, data?.providerSk);

    this.meetingType = data?.meetingType ?? null;
    this.providerMeetingSk = data?.meetingSk ?? null;
    this.personSk = data?.personSk ?? null;
    this.location = data?.location ?? null;
    this.offerDate = data?.startDate ? formatStartToAPI(data?.startDate) : null;
    this.currScheduleDt = currScheduleDtStr;
    this.currScheduleEndDt = currScheduleEndDtStr;
    this.rescheduleReason = data?.rescheduleReason ?? null;
    this.dateRescheduled = data?.dateRescheduled ?? null;
    this.lastModUser = data?.lastModUser ?? null;
    this.lastModTs = data?.lastModTs ?? null;
    this.meetingName = data?.sessionType?.description ?? null;
    this.subMeetingType = data?.subMeetingType ?? null;
    this.assignments = data?.assignments ?? null;
    this.recurringMeetingInfo = new RecurringMeetingModel(data);
    this.isRecurring = data?.isRecurring;
    this.assignments = map(data?.assignments, (a: any) => new Assignments(a));
    this.status = data?.status ?? null;
    this.sessionType = data?.sessionType?.id ? data?.sessionType?.id : data?.sessionType ?? null;
    this.studentSk = data?.studentSk ?? null;
    this.providerSk = data?.providerSk ?? null;
    this.locationType = data?.locationType?.id ?? null;
    this.locationKey = data?.locationKey ?? null;
    this.students = data?.students ?? null;
  }
}

export class Assignments {
  assignmentSk: string;
  constructor(data: any) {
    this.assignmentSk = data.assignmentSk;
  }
}
